import { render, staticRenderFns } from "./Innovation.vue?vue&type=template&id=c023e47e&scoped=true"
import script from "./Innovation.vue?vue&type=script&lang=js"
export * from "./Innovation.vue?vue&type=script&lang=js"
import style0 from "./Innovation.vue?vue&type=style&index=0&id=c023e47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c023e47e",
  null
  
)

export default component.exports